import React from 'react';
import { countries } from './countries';
import Select from 'rc-select';

import './rc-select.css';

const CountryCodeSelect = ({ style, onChange, setDirty, value }) => {
  return (
    <Select
      style={style}
      showArrow={false}
      showSearch={true}
      optionLabelProp='label'
      dropdownMatchSelectWidth={288}
      filterOption={(input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) > -1;
      }}
      optionFilterProp='children'
      placeholder={<span>-- Country --</span>}
      onChange={onChange}
      onBlur={setDirty}
      value={value !== '' ? value : undefined}
    >
      {countries.map((v, i) => (
        <Select.Option key={i} value={v.alpha2code} label={v.name}>
          {v.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CountryCodeSelect;



// WEBPACK FOOTER //
// ./src/ndc/request/countryCodeSelect.js